// extracted by mini-css-extract-plugin
export var postDetail = "post-module--post-detail--Zfuu3";
export var postContent = "post-module--post-content--CpBjm";
export var postDescription = "post-module--post-description--yd45K";
export var sidebar = "post-module--sidebar--mEynY";
export var relatedPostRow = "post-module--related-post-row--ZvJX2";
export var tag = "post-module--tag--xG4M9";
export var followBtn = "post-module--follow-btn--BHNl1";
export var relatedPost = "post-module--relatedPost--xpAV9";
export var description = "post-module--description--zo4y3";